<ng-template #otherCoverageSection>
  <div
    *ngIf="(requestType.selfPayTypeCode === 'C' && selfPay.isSEBB) || requestType.selfPayTypeCode === 'OEC' || (selfPay.isPEBB && selfPay.isCobraSOE)"
    fxLayout="row" fxFlexFill>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Are you covered by another group medical plan?</label>
      <yes-no [name]="'coveredByOtherMedical' + idx" style="width: auto;" orientation="horizontal-list"
        [stretch]="false" [(ngModel)]="currentDependent.coveredByOtherMedicalInd"></yes-no>
    </kendo-formfield>
    <div class="form-inline">
      <date-picker #coveredByOtherMedicalDate="ngModel" [name]="'coveredByOtherMedicalDate' + idx"
        [(ngModel)]="currentDependent.coveredByOtherMedicalDate">
        <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
      </date-picker>
    </div>
  </div>
  <div
    *ngIf="(requestType.selfPayTypeCode === 'C' && selfPay.isSEBB) || requestType.selfPayTypeCode === 'OEC' || (selfPay.isPEBB && selfPay.isCobraSOE)"
    fxLayout="row" fxFlexFill>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Are you covered by another group dental plan?</label>
      <yes-no [name]="'coveredByOtherDental' + idx" style="width: auto;" orientation="horizontal-list" [stretch]="false"
        [(ngModel)]="currentDependent.coveredByOtherDentalInd"></yes-no>
    </kendo-formfield>
    <div class="form-inline">
      <date-picker #coveredByOtherDentalDate="ngModel" [name]="'coveredByOtherDentalDate' + idx"
        [(ngModel)]="currentDependent.coveredByOtherDentalDate">
        <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
      </date-picker>
    </div>
  </div>
  <div
    *ngIf="(requestType.selfPayTypeCode === 'C' && selfPay.isSEBB) || requestType.selfPayTypeCode === 'OEC' || (selfPay.isPEBB && pebbVisionActive && selfPay.isCobraSOE)"
    fxLayout="row" fxFlexFill>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Are you covered by another group vision plan?</label>
      <yes-no [name]="'coveredByOtherVision' + idx" style="width: auto;" orientation="horizontal-list" [stretch]="false"
        [(ngModel)]="currentDependent.coveredByOtherVisionInd"></yes-no>
    </kendo-formfield>
    <div class="form-inline">
      <date-picker #coveredByOtherVisionDate="ngModel" [name]="'coveredByOtherVisionDate' + idx"
        [(ngModel)]="currentDependent.coveredByOtherVisionDate">
        <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
      </date-picker>
    </div>
  </div>
  <div
    *ngIf="requestType.selfPayTypeCode === 'C' || requestType.selfPayTypeCode === 'OEC' || (selfPay.isPEBB && (selfPay.isCobraInitial || selfPay.isCobraSOE))"
    fxLayout="row" fxFlexFill>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Do you receive Social Security Disability?</label>
      <yes-no [name]="'coveredByOtherSSD' + idx" style="width: auto;" orientation="horizontal-list" [stretch]="false"
        [(ngModel)]="currentDependent.coveredByOtherSSDInd"></yes-no>
    </kendo-formfield>
    <div class="form-inline">
      <date-picker #coveredByOtherSSDDate="ngModel" [name]="'coveredByOtherSSDDate' + idx"
        [(ngModel)]="currentDependent.coveredByOtherSSDDate">
        <span style="white-space: nowrap; margin-right: 20px">If yes, effective date</span>
      </date-picker>
    </div>
  </div>
  <h4 *ngIf="requestType.selfPayTypeCode === 'C' || requestType.selfPayTypeCode === 'OEC'">
    <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
    If you answered Yes to receiving Social Security Disability, you must upload or send a copy of your Social
    Security Disability Award letter. If mailing, write your last name and the last four digits of
    your Social Security number on the copy so we can identify your account. You and your enrolled dependents may be
    eligible for additional months of coverage.
  </h4>
</ng-template>

<form nativeControlElement #dependentForm="ngForm" #formContainer
  *ngIf="!isPebbRetireeVision && !isCobraOE && !isPebbCobraInitial && !isPebbCobraSOE && !(selfPay.isPEBB && selfPay.isRetireeSOE)">
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="25">
      <label [for]="'socialSecurityNumber' + idx">SSN</label>
      <input [disabled]="true" #ssn="ngModel" type="text" class="form-control" minlength="11" maxlength="11"
        [ngModel]="(!noSSN ? currentDependent.socialSecurityNumber : null) | ssn"
        (ngModelChange)="currentDependent.socialSecurityNumber = $event?.split('-').join('')"
        [name]="'socialSecurityNumber' + idx" [id]="'socialSecurityNumber' + idx" />
    </div>
    <div class="form-group" fxFlex="25">
      <date-picker #birthDate="ngModel" [name]="'birthDate' + idx" label="Birth date"
        [(ngModel)]="currentDependent.birthDate"></date-picker>
    </div>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Sex assigned at birth<sup>1</sup></label>
      <radio-list [name]="'birthSex' + idx" [(ngModel)]="currentDependent.birthSex"
        [items]="{ Male: 'M', Female: 'F' }"></radio-list>
    </kendo-formfield>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="50">
      <label [for]="'lastName' + idx">Last Name</label>
      <input type="text" class="form-control" [name]="'lastName' + idx" [id]="'lastName' + idx"
        [(ngModel)]="currentDependent.lastName" />
    </div>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Gender Identity<sup>2</sup></label>
      <radio-list [name]="'genderIdentity' + idx" [(ngModel)]="currentDependent.genderIdentity"
        [items]="{ Male: 'M', Female: 'F', X: 'X' }"></radio-list>
    </kendo-formfield>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="50">
      <label [for]="'firstName' + idx">First Name</label>
      <input type="text" class="form-control" [id]="'firstName' + idx" [name]="'firstName' + idx"
        [(ngModel)]="currentDependent.firstName" />
    </div>
    <div class="form-group" fxFlex="15">
      <label [for]="'middleInitial' + idx">Middle Initial</label>
      <input type="text" class="form-control" [id]="'middleInitial' + idx" [name]="'middleInitial' + idx"
        [(ngModel)]="currentDependent.middleName" />
    </div>
    <div class="form-group" fxFlex="15">
      <label [for]="'suffix' + idx">Suffix</label>
      <input type="text" class="form-control" [id]="'suffix' + idx" [name]="'suffix' + idx"
        [(ngModel)]="currentDependent.suffix" />
    </div>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill
    *ngIf="currentDependent.isSpouse">
    <div class="form-group" fxFlex="25">
      <date-picker #dateOfMarriage="ngModel" [name]="'dateOfMarriage' + idx" label="Date of marriage"
        [(ngModel)]="currentDependent.partnershipStartDate"></date-picker>
    </div>
  </div>
  <checkbox bold name="addressSameAsSubscriber{{idx}}" [(ngModel)]="currentDependent.addressSameAsSubscriber">
    {{ (selfPay?.isLwopOE && selfPay?.isPEBB? 'Street ' : (selfPay?.isLwopInitial ? 'Permantent street ' : 'Residential ')) }}address is the same as subscriber
  </checkbox>
  <div class="form-row" *ngIf="!currentDependent.addressSameAsSubscriber">
    <address #residentialAddress view="inline" name="residentialAddress" [hideCounty]="!(selfPay.isPEBB && selfPay.isLwopOE)"
      [(ngModel)]="currentDependent"></address>
    <div
      *ngIf="!selfPay.isRetoreeSOE && !(selfPay.isSEBB && selfPay.isCOBRA) && !(selfPay.isPEBB && selfPay.isCobraSOE)"
      style="margin-bottom: 20px;">
      Enrollment in Medicare Advantage Plans (MAPD) or Medicare Part D has specific requirements associated with
      residential addresses.
      PO boxes and out-of-country addresses may not be eligible for MAPD/Part D enrollment and will need to be reviewed
      by HCA for eligibility.
      Proof of residence may need to be provided.
    </div>
    <div style="margin-bottom: 20px;" *ngIf="selfPay.isRetireeSOE">
      If you are enrolled in Medicare, this information needs to match your Medicare record to avoid delay to coverage
      starting.
      Proof of address may need to be provided.
    </div>
  </div>
  <div class="form-row" fxFlexFill>
    <div fxLayout="column" fxFlex="100">
      <div class="hca-selfPay-divider" fxFlex="45"></div>
      <span class="hca-selfPay-small-note" fxFlex="100"> 1. This field is required for health care services. </span>
      <span class="hca-selfPay-small-note" fxFlex="100">
        2. This field is not required for enrollment. Your response is optional and will be kept private to the extent allowable by law. 
        Gender X means a gender that is not exclusively male nor female. To learn more visit 
        <a target="_blank" href="https://www.hca.wa.gov/about-hca/other-administrative-activities/gender-identity-information">Gender X</a>.
        <br/><br/>
      </span>
    </div>
  </div>
  <div *ngIf="requestType.selfPayTypeCode === 'C'">
    <label class="k-label">Is this person coverage by another group medical plan?</label>
    <yes-no [name]="'enrolledInAnotherGroupMedical' + idx" style="width: auto;" orientation="horizontal-list"
      [stretch]="false" [(ngModel)]="currentDependent.enrolledInAnotherGroupMedical"></yes-no>
    <div class="form-group row">
      <date-picker #medicarePartDEffectiveDate="ngModel" [name]="'enrolledInAnotherGroupMedicalEffectiveDate' + idx"
        [required]="currentDependent.enrolledInAnotherGroupMedical"
        [(ngModel)]="currentDependent.enrolledInAnotherGroupMedicalEffectiveDate">
        <span class="col-form-label">If yes, effective date</span>
      </date-picker>
    </div>

    <label class="k-label">Is this person coverage by another group dental plan?</label>
    <yes-no [name]="'enrolledInAnotherGroupDental' + idx" style="width: auto;" orientation="horizontal-list"
      [stretch]="false" [(ngModel)]="currentDependent.enrolledInAnotherGroupDental"></yes-no>
    <div class="form-group row">
      <date-picker #medicarePartDEffectiveDate="ngModel" [name]="'enrolledInAnotherGroupDentalEffectiveDate' + idx"
        [required]="currentDependent.enrolledInAnotherGroupDental"
        [(ngModel)]="currentDependent.enrolledInAnotherGroupDentalEffectiveDate">
        <span class="col-form-label">If yes, effective date</span>
      </date-picker>
    </div>
    <label class="k-label">Does this person receive social security disability?</label>
    <yes-no [name]="'socialSecurityDisability' + idx" style="width: auto;" orientation="horizontal-list"
      [stretch]="false" [(ngModel)]="currentDependent.socialSecurityDisability"></yes-no>
    <div class="form-group row">
      <date-picker #medicarePartDEffectiveDate="ngModel" [name]="'socialSecurityDisabilityEffectiveDate' + idx"
        [required]="currentDependent.socialSecurityDisability"
        [(ngModel)]="currentDependent.socialSecurityDisabilityEffectiveDate">
        <span class="col-form-label">If yes, effective date and attach a copy of their Social Security Disability
          Award letter. Write your last name and last four digits of your Social Security number on the copy. You
          and your enrolled dependents may be eligible for additional months of coverage.
        </span>
      </date-picker>
    </div>
  </div>
  <div
    *ngIf="requestType.selfPayTypeCode !== 'U' && requestType.selfPayTypeCode !== 'SOEU' && requestType.selfPayTypeCode !== 'OEU'">
    <div class="form-row" fxFlexFill style="margin-bottom: 20px">
      <span class="soe-form-small-header">Medicare Information</span>
      <span style="width: 100%; margin-bottom: 15px"><b>Are you enrolled in Medicare Part A or Part B?</b></span>
      <div fxLayout="row" fxFlexFill>
        <kendo-formfield [orientation]="'horizontal'" fxFlex="20" role="radiogroup"
          [attr.aria-labelledby]="'medicarePartAEnrolledInd' + idx + '_label'">
          <label [id]="'medicarePartAEnrolledInd' + idx + '_label'" class="k-label">Part A (hospital)</label>
          <yes-no [name]="'medicarePartAEnrolledInd' + idx" style="width: auto;" orientation="horizontal-list"
            (ngModelChange)="updateMedicarePartA($event)" [stretch]="false" [(ngModel)]="currentDependent.medicarePartAInd"></yes-no>
        </kendo-formfield>
        <div class="form-inline">
          <date-picker #medicarePartAEffectiveDate="ngModel" [name]="'medicarePartAEffectiveDate' + idx" labelFlex="70"
            inputFlex="30" [min]="currentDependent.birthDate"
            [required]="currentDependent.medicarePartAInd"
            [(ngModel)]="currentDependent.medicarePartADate">
            <span style="white-space: nowrap; margin-right: 20px">If yes, enter the effective date shown on the Medicare
              card</span>
          </date-picker>
        </div>
      </div>
      <div fxLayout="row" fxFlexFill style="margin-top: 15px">
        <kendo-formfield [orientation]="'horizontal'" fxFlex="20" role="radiogroup"
          [attr.aria-labelledby]="'medicarePartBEnrolledInd' + idx + '_label'">
          <label [id]="'medicarePartBEnrolledInd' + idx + '_label'" class="k-label">Part B (medical)</label>
          <yes-no [name]="'medicarePartBEnrolledInd' + idx" style="width: auto;" orientation="horizontal-list"
            (ngModelChange)="updateMedicarePartB($event)" [stretch]="false" [(ngModel)]="currentDependent.medicarePartBInd"></yes-no>
        </kendo-formfield>
        <div class="form-inline">
          <date-picker #medicarePartBEffectiveDate="ngModel" [name]="'medicarePartBEffectiveDate' + idx" labelFlex="70"
            inputFlex="30" [min]="currentDependent.birthDate"
            [required]="currentDependent.medicarePartBInd"
            [(ngModel)]="currentDependent.medicarePartBDate">
            <span style="white-space: nowrap; margin-right: 20px">If yes, enter the effective date shown on the Medicare
              card</span>
          </date-picker>
        </div>
      </div>
      <div class="form-group" fxFill>
        <label for="suffix">Medicare number (11 digits)</label> <b> Please verify the accuracy of your Medicare
          Beneficiary Number (MBI)</b>
        <input pattern="[a-zA-Z0-9]*" type="text" class="form-control" id="medicareNumber" name="medicareNumber"
          [(ngModel)]="currentDependent.medicareNumber" minlength="11" maxlength="11" />
      </div>
      <p style="margin-top: 20px" *ngIf="!isCobra || agency != 'SEBB' || (selfPay.isPEBB && selfPay.isCobraInitial)">
        If Yes, proof is required. Upload or mail a copy of all pages of their entire Medicare benefit verification
        letter or a copy of their Medicare card if we don't already have a copy. If mailing, write your last name and
        the last four digits of your Social Security Number on the copy so we can identify the account. If your
        dependent is eligible for Medicare, they must enroll and stay enrolled in both Medicare Part A and
        Part B<ng-container *ngIf="!selfPay.isRetireeInitial"> to keep {{agency}} retiree health plan coverage</ng-container>.
      </p>
      <p *ngIf="selfPay.isPEBB && selfPay.isCobraSOE">
        If Yes, proof is required. Attach a copy of your Medicare benefit verification letter or a copy of your Medicare
        card to this form. Write your full
        name and the last four digits of your Social Security number on the copy. You could face penalties if you don't
        enroll in Medicare Part A and Part B
        when you become eligible. Federal rules do not allow you to waive Medicare while on COBRA coverage.
      </p>
      <p style="margin-top: 20px" *ngIf="(!isCobra || agency != 'SEBB') && !selfPay.isRetireeInitial">
        If Yes, they may enroll only in Premera Blue Cross Medicare Supplement Plan G. Plan F enrollees may stay in
        the plan. If they want to enroll in any other PEBB medical plan, they must disenroll from the Part D plan.
      </p>
    </div>
    <div class="form-row" fxFlexFill>
      <h3 class="mobile-text-centered" fxFlexFill>I want to enroll this dependent in..</h3>
      <div fxFlexFill *ngIf="requestType.selfPayTypeCode === 'R' || requestType.selfpayTypeCode === 'OER'" style="margin-bottom: 20px">
        (By choosing to enroll into coverage for yourself, your dependent(s) are automatically enrolled in the same plan
        as you, with some exceptions based on eligibility for Medicare Part A and Part  B.)
        <br/><br/>
      </div>
    </div>
    <div class="form-row" fxFlexFill style="margin-bottom: 20px">
      <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
        <checkbox [name]="'medicalCover' + idx" [(ngModel)]="currentDependent.medicalCoverInd" label="Medical">
        </checkbox>
      </div>
      <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between">
        <checkbox [name]="'dentalCover' + idx" [(ngModel)]="currentDependent.dentalCoverInd" label="Dental"></checkbox>
      </div>
      <div fxLayout="column" fxFlex="33" fxFlex.fxFlex.lt-md="100"
        fxLayoutAlign="space-between">
        <checkbox [name]="'visionCover' + idx" [(ngModel)]="currentDependent.visionCoverInd" label="Vision" [disabled]="(!isSebbCobra && currentDependent.medicarePartBInd)"></checkbox>
      </div>
    </div>
    <div class="info margin-bottom: 20px">Premium surcharges do not apply if subscriber is enrolled in Medicare Part A and Part B<br/><br/></div>
  </div>
  <div *ngIf="requestType.selfPayTypeCode !== 'R' && !(selfPay.isPEBB && selfPay.isRetireeSOE)">
    <div class="form-row" style="padding-top: 20px" fxFlexFill>
      <h3 class="mobile-text-centered">Choose one box for each type of coverage</h3>
    </div>
    <div class="form-row" fxFlexFill>
      <div class="form-row" fxFlexFill style="margin-bottom: 20px">
        <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
          <span class="soe-form-small-header">Medical coverage (Select all that apply)</span>
          <div>You may choose to continue coverage and then terminate it at a future date by selecting to both continue
            and terminate coverage and providing a termination date and reason below.</div>
          <div fxLayout="row">
            <div fxLayout="column" fxFlex="50">
              <checkbox (change)="updateCoverageContinue($event, 'medicalDoNotContinueCoverage')"
                [name]="'continueMedical' + idx" [required]="!currentDependent.medicalDoNotContinueCoverage"
                [(ngModel)]="currentDependent.medicalContinueCoverageInd" label="Continue coverage"></checkbox>
              <checkbox [name]="'termMedical' + idx" [(ngModel)]="currentDependent.medicalTerminateCoverage"
                label="Terminate coverage"></checkbox>
            </div>
            <div fxLayout="column" fxFlex="50">
              <checkbox [name]="'doNotContinueMedical' + idx"
                [required]="!currentDependent.medicalDoNotContinueCoverage && !currentDependent.medicalContinueCoverageInd"
                [(ngModel)]="currentDependent.medicalDoNotContinueCoverage" label="Do not continue coverage"
                (change)="updateCoverageContinue($event, 'medicalContinueCoverageInd')">
              </checkbox>
              <div class="form-inline" style="margin: 15px 15px 0px 0px">
                <date-picker #medicalTerminateCoverageDate="ngModel" [name]="'medicalTerminateCoverageDate' + idx"
                  [required]="currentDependent.medicalTerminateCoverage"
                  [(ngModel)]="currentDependent.medicalTerminateCoverageDate">
                </date-picker>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxFlexFill>
            <div [class.required]="currentDependent.medicalTerminateCoverage" class="form-group" fxFlex="100"
              style="margin-right: 15px">
              <label [for]="'medicalTermReason' + idx">If terminating coverage, include reason</label>
              <input [required]="currentDependent.medicalTerminateCoverage" type="text" class="form-control"
                [id]="'medicalTermReason' + idx" [name]="'medicalTermReason' + idx"
                [(ngModel)]="currentDependent.medicalTerminateCoverageReason" />
            </div>
          </div>
        </div>
        <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
          <span class="soe-form-small-header">Dental coverage</span>
          <div fxLayout="row">
            <div fxLayout="column" fxFlex="50">
              <checkbox [name]="'continueDental' + idx" [required]="!currentDependent.dentalDoNotContinueCoverage"
                (change)="updateCoverageContinue($event, 'dentalDoNotContinueCoverage')"
                [(ngModel)]="currentDependent.dentalContinueCoverageInd" label="Continue coverage">
              </checkbox>
              <checkbox [name]="'termDental' + idx" [(ngModel)]="currentDependent.dentalTerminateCoverage"
                label="Terminate coverage"></checkbox>
            </div>
            <div fxLayout="column" fxFlex="50">
              <checkbox [name]="'doNotContinueDental' + idx"
                [required]="!currentDependent.dentalDoNotContinueCoverage && !currentDependent.dentalContinueCoverageInd"
                (change)="updateCoverageContinue($event, 'dentalContinueCoverageInd')"
                [(ngModel)]="currentDependent.dentalDoNotContinueCoverage" label="Do not continue coverage">
              </checkbox>
              <div class="form-inline" style="margin: 15px 15px 0px 0px">
                <date-picker #dentalTerminateCoverageDate="ngModel" [name]="'dentalTerminateCoverageDate' + idx"
                  [required]="currentDependent.dentalTerminateCoverage"
                  [(ngModel)]="currentDependent.dentalTerminateCoverageDate">
                </date-picker>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxFlexFill>
            <div [class.required]="currentDependent.medicalTerminateCoverage" class="form-group" fxFlex="100"
              style="margin-right: 15px">
              <label [for]="'dentalTermReason' + idx">If terminating coverage, include reason</label>
              <input [required]="currentDependent.dentalTerminateCoverage" type="text" class="form-control"
                [id]="'dentalTermReason' + idx" [name]="'dentalTermReason' + idx"
                [(ngModel)]="currentDependent.dentalTerminateCoverageReason" />
            </div>
          </div>
        </div>
        <h4>
          <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
          If you terminate all coverage, you will not be eligible to enroll again in {{agency}} Continuation Coverage
          unless you regain eligibility.
        </h4>
      </div>
      <div fxLayout="column" fxFlex="100" fxFlex.fxFlex.lt-md="100"
        fxLayoutAlign="space-between" class="fxGap-small">
        <span class="soe-form-small-header">Vision coverage</span>
        <div fxLayout="row">
          <div fxLayout="column" fxFlex="100">
            <checkbox [name]="'continueVision' + idx" [required]="!currentDependent.visionDoNotContinueCoverage"
              (change)="updateCoverageContinue($event, 'visionDoNotContinueCoverage')"
              [(ngModel)]="currentDependent.visionContinueCoverageInd" label="Continue coverage">
            </checkbox>
            <checkbox [name]="'termVision' + idx" [(ngModel)]="currentDependent.visionTerminateCoverage"
              label="Terminate coverage"></checkbox>
          </div>
          <div fxLayout="column" fxFlex="50">
            <checkbox [name]="'doNotContinueVision' + idx"
              [required]="!currentDependent.visionDoNotContinueCoverage && !currentDependent.visionContinueCoverageInd"
              (change)="updateCoverageContinue($event, 'visionContinueCoverageInd')"
              [(ngModel)]="currentDependent.visionDoNotContinueCoverage" label="Do not continue coverage">
            </checkbox>
            <div class="form-inline" style="margin: 15px 15px 0px 0px">
              <date-picker #visionTerminateCoverageDate="ngModel" [name]="'visionTerminateCoverageDate' + idx"
                [required]="currentDependent.visionTerminateCoverage"
                [(ngModel)]="currentDependent.visionTerminateCoverageDate">
              </date-picker>
            </div>
          </div>
        </div>
        <div fxLayout="row" fxFlexFill>
          <div class="form-group" fxFlex="100" style="margin-right: 15px">
            <label [class.required]="currentDependent.visionTerminateCoverage" for="visionTermReason">If terminating
              coverage,
              include reason</label>
            <input [required]="currentDependent.visionTerminateCoverage" type="text" class="form-control"
              name="visionTermReason" [(ngModel)]="currentDependent.visionTerminateCoverageReason" />
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="otherCoverageSection"></ng-container>
    </div>
  </div>

  <div *ngIf="requestType.selfPayTypeCode === 'OER'" fxLayoutAlign="row">
    <fa-icon fxFlex="5" [icon]="icons.faExclamationCircle" color="primary" size="1x"></fa-icon><span>Premium surcharges
      do not apply if subscriber is enrolled in Medicare Part A and Part B</span>
  </div>

  <div class="form-row" fxFlexFill style="margin-bottom: 20px">
    <div *ngIf="currentDependent.birthDate < thirteenYearsDate" fxLayout="column" fxFlex="100"
      fxLayoutAlign="space-between">
      <span class="selfPay-form-small-header">Tobacco {{ selfPay.isPEBB && (selfPay.isCobraOE || selfPay.isRetireeOE) ?
        'uses' : 'use' }} premium surcharge</span>
      <span style="padding-bottom: 10px">
        <span *ngIf="currentDependent.relationshipTypeName === 'Spouse/state-registered domestic partner'">
          Response required if you are enrolling your spouse or state-registered domestic partner (SRDP) in medical
          coverage. If you check Yes or do not check any boxes below, you will be charged the
          $25-per-account premium surcharge in addition to your monthly medical premium.
        </span>
        <span *ngIf="currentDependent.relationshipTypeName !== 'Spouse/state-registered domestic partner'">
          Response required if you are enrolling dependents age 13 and older in medical coverage. If you check Yes or do
          not check any boxes below, you will be charged the $25-per-account premium
          surcharge in addition to your monthly medical premium.
        </span>
        <ng-container *ngIf="selfPay.isPEBB && selfPay.isLwopOE">
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/tobacco-use-surcharge">Learn about this surcharge before you attest</a>.  
        </ng-container>
        <ng-container *ngIf="selfPay.isSEBB && selfPay.isLwopOE">
          <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/tobacco-use-surcharge">Learn about this surcharge before you attest</a>.  
        </ng-container>
        <br />
        <br />
        <b>Does the tobacco use premium surcharge apply to you?</b> Check one:
      </span>
      <div
        *ngIf="requestType.selfPayTypeCode !== 'U' && requestType.selfPayTypeCode !== 'OEU' && requestType.selfPayTypeCode !== 'SOEU' && (agency != 'SEBB' || !isCobra)"
        class="k-form-field bigger" style="margin-bottom: 15px">
        <checkbox [name]="'tobaccoNA' + idx" [(ngModel)]="currentDependent.surchargeNA" (change)="updateTobacco()">
          Subscriber is enrolled in Medicare Part A and Part B. Premium surcharge does not apply.
        </checkbox>
      </div>
      <div class="k-form-field bigger" style="margin-bottom: 15px">
        <radio [name]="'tobaccoYes' + idx" [disabled]="currentDependent.surchargeNA" radioAsCheckbox [value]="true"
          [(ngModel)]="currentDependent.tobaccoUseInd">
          <b>Yes,</b> I am subject to the $25 premium surcharge. This dependent has used tobacco products in the past
          two months.
        </radio>
      </div>
      <div class="k-form-field bigger" style="margin-bottom: 20px" class="hca-mid-sz">
        <radio [name]="'tobaccoNo' + idx" [disabled]="currentDependent.surchargeNA" radioAsCheckbox [value]="false"
          [(ngModel)]="currentDependent.tobaccoUseInd">
          <b>No,</b> I am not subject to the $25 premium surcharge. This dependent has not used tobacco products in the
          past two months or has enrolled in or accessed 
          <span *ngIf="!selfPay.isSEBB && !selfPay.isLwopOE">one of </span>
          <span *ngIf="selfPay.isPEBB && selfPay.isLwopOE">one of the </span>
          <a target="_blank" [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-sebb' : 'https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-pebb'"> tobacco cessation
          resources<span *ngIf="!selfPay.isLwopInitial && !selfPay.isLwopOE"> noted</span></a>.
        </radio>
      </div>
    </div>
  </div>

  <div *ngIf="currentDependent.relationshipTypeName === 'Spouse/state-registered domestic partner'" class="form-row"
    fxFlexFill style="margin-bottom: 20px">
    <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between">
      <span class="selfPay-form-small-header">Spouse or state-registered domestic partner (SRDP) coverage premium
        surcharge </span>
      <span style="padding-bottom: 10px">
        Response required if you are enrolling your spouse or SRDP in medical coverage. The {{agency}} Program requires
        a $50 premium surcharge in addition to your monthly medical premium if you are
        enrolling your spouse or SRDP in {{agency}} medical and they have chosen not to enroll in another employer-based
        group medical that is comparable to PEBB's Uniform Medical Plan Classic.
        <div *ngIf="((selfPay.isLwopOE || selfPay.isLwopInitial) && selfPay.isPEBB) || (selfPay.isSEBB && (selfPay.isCobraInitial || selfPay.isLwopInitial))">
          <br/>
          <a target="_blank" [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/school-employees/surcharges' : 'https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/spousal-coverage-surcharge'">Learn about this surcharge</a> before you make your attestation.
        </div>
        <br />
        <br />
        <b>Answer these questions for your spouse or SRDP in {{coverageYear}}:</b>
        <div fxLayout="column">
          <ol class="hca-ordered-list">
            <li><yes-no name="spouseAttestQ1" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ1" (change)="spousalChange(currentDependent)">
                Are you covering your spouse or SRDP in a {{agency}} medical plan?
              </yes-no></li>
            <li><yes-no name="spouseAttestQ2" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ2" (change)="spousalChange(currentDependent)">
                Will they be eligible for medical coverage through their employer? (If they will not
                be employed, answer No.)
              </yes-no></li>
            <li><yes-no name="spouseAttestQ3" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ3" (change)="spousalChange(currentDependent)">
                Will their employer offer at least one medical plan that serves their county of residence?
              </yes-no></li>
            <li><yes-no name="spouseAttestQ4" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ4" (change)="spousalChange(currentDependent)">
                Have they chosen not to enroll in their employer's medical coverage?
              </yes-no></li>
            <li><yes-no name="spouseAttestQ5" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ5" (change)="spousalChange(currentDependent)">
                Will the coverage offered by their employer <b>not</b> be through the PEBB Program, SEBB Program, or a TRICARE plan?<br/> 
                    Answer Yes if their employer does <b>not</b> offer PEBB or SEBB coverage, or a TRICARE plan. <br/>
                    Answer No if their employer offers PEBB or SEBB coverage, or a TRICARE plan.
              </yes-no></li>
            <li><yes-no name="spouseAttestQ6" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ6" (change)="spousalChange(currentDependent)">
                Will their share of the medical premium through their employer be less than 
                ${{ (coverageYear >= 2026 ? '137.76' : (coverageYear == 2025 ? '126.36' : '117.81'))}} per month?
              </yes-no></li>
          </ol>
        </div>
        If you answered No to any of these questions, check no below. You will not be charged the surcharge.
        If you answered Yes to all {{ selfPay.isPEBB && selfPay.isCobraOE ? '' : 'of' }} these questions:
        <br />
        <br />
        <ol>
          <li>Ask your spouse or SRDP for the Summary of Benefits and Coverage (SBC) for all medical plans that:
            <ol type="a">
              <li>Serve their county of residence.</li>
              <li>Have a monthly premium of less than 
                ${{ (coverageYear >= 2026 ? '137.76' : (coverageYear == 2025 ? '126.36' : '117.81'))}}
                per month for the
                employee.</li>
            </ol>

          </li>
          <li>Use the SBC information to answer the questions in the {{agency}} Spousal Plan Calculator online tool. You
            will get a Yes or No response from the calculator. Enter your response below.</li>
        </ol>
        <br />
        <b>Does the spouse or SRDP coverage premium surcharge apply to you?</b> Check one:
      </span>
      <radio *ngIf="selfPay.isPEBB && (selfPay.isCobraOE || selfPay.isLwopOE)" [name]="'spouseSurchargeNAMedicare' + idx" radioAsCheckbox
          [disabled]="currentDependent.surchargeNA" value="NAMedicare"
          [(ngModel)]="currentDependent.spouseSurchargeTriState">
          No, I am enrolled in Medicare Part A and Part B. The premium surcharge does not apply.
      </radio>
      <div fxlayout="row" fxFlex="100" fxLayoutAlign="space-between">
        <radio [name]="'spousalYes' + idx" radioAsCheckbox [disabled]="currentDependent.surchargeNA" value="Y"
          [(ngModel)]="currentDependent.spouseSurchargeTriState">
          <b>Yes,</b> I am subject to the $50 premium surcharge. I completed the {{coverageYear}}
          <a [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/school-employees/spousal-plan-calculator' : 'https://www.hca.wa.gov/employee-retiree-benefits/spousal-plan-calculator'"
            target="_blank">{{agency}} Spousal Plan Calculator</a> online.
        </radio>
        <span class="selfPay-form-small-header" fxFlex="40">
          <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
          If you check <b>Yes</b> or do not check any boxes below, you will be charged the $50 spouse or SRDP coverage
          premium surcharge.
        </span>
      </div>
      <radio [name]="'spousalNo' + idx" radioAsCheckbox [disabled]="currentDependent.surchargeNA" value="N"
        [(ngModel)]="currentDependent.spouseSurchargeTriState">
        <b>No,</b> I am not subject to the $50 premium surcharge. I completed the {{agency}} Spousal Plan Calculator
        online.
      </radio>
      <radio [name]="'spousalHelp' + idx" radioAsCheckbox [disabled]="currentDependent.surchargeNA" value="H"
        [(ngModel)]="currentDependent.spouseSurchargeTriState">
        The {{agency}} Program to help determine if premium surcharge applies. I am completing and submitting a printed
        {{agency}} Spousal Plan
        Calculator.
      </radio>
    </div>
  </div>

  <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between">
    <button fxFlex="30" (click)="cancelChanges()" class="btn btn-light">Cancel</button>
    <button fxFlex="30" (click)="emitSubmitDependent(formContainer)" class="btn btn-primary">Save changes</button>
  </div>
</form>



<!-- RETIREE OE2025 -->

<form nativeControlElement #dependentForm="ngForm" #formContainer
  *ngIf="isPebbRetireeVision || isCobraOE || isPebbCobraInitial || isPebbCobraSOE || (selfPay.isPEBB && selfPay.isRetireeSOE)">
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="25">
      <label [for]="'socialSecurityNumber' + idx">SSN</label>
      <input [disabled]="true" #ssn="ngModel" type="text" class="form-control" minlength="11" maxlength="11"
        [ngModel]="(!noSSN ? currentDependent.socialSecurityNumber : null) | ssn"
        (ngModelChange)="currentDependent.socialSecurityNumber = $event?.split('-').join('')"
        [name]="'socialSecurityNumber' + idx" [id]="'socialSecurityNumber' + idx" />
    </div>
    <div class="form-group" fxFlex="25">
      <date-picker #birthDate="ngModel" [name]="'birthDate' + idx" label="Birth date"
        [(ngModel)]="currentDependent.birthDate"></date-picker>
    </div>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Sex assigned at birth<sup>1</sup></label>
      <radio-list [name]="'birthSex' + idx" [(ngModel)]="currentDependent.birthSex"
        [items]="{ Male: 'M', Female: 'F' }"></radio-list>
    </kendo-formfield>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="50">
      <label [for]="'lastName' + idx">Last Name</label>
      <input type="text" class="form-control" [name]="'lastName' + idx" [id]="'lastName' + idx"
        [(ngModel)]="currentDependent.lastName" />
    </div>
    <kendo-formfield [orientation]="'horizontal'" fxFlex="40">
      <label class="k-label">Gender Identity<sup>2</sup></label>
      <radio-list [name]="'genderIdentity' + idx" [(ngModel)]="currentDependent.genderIdentity"
        [items]="{ Male: 'M', Female: 'F', X: 'X' }"></radio-list>
    </kendo-formfield>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill>
    <div class="form-group" fxFlex="50">
      <label [for]="'firstName' + idx">First Name</label>
      <input type="text" class="form-control" [id]="'firstName' + idx" [name]="'firstName' + idx"
        [(ngModel)]="currentDependent.firstName" />
    </div>
    <div class="form-group" fxFlex="15">
      <label [for]="'middleInitial' + idx">Middle Initial</label>
      <input type="text" class="form-control" [id]="'middleInitial' + idx" [name]="'middleInitial' + idx"
        [(ngModel)]="currentDependent.middleName" />
    </div>
    <div class="form-group" fxFlex="15">
      <label [for]="'suffix' + idx">Suffix</label>
      <input type="text" class="form-control" [id]="'suffix' + idx" [name]="'suffix' + idx"
        [(ngModel)]="currentDependent.suffix" />
    </div>
  </div>
  <div class="form-row" fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between" fxFlexFill
    *ngIf="currentDependent.isSpouse">
    <div class="form-group" fxFlex="25">
      <date-picker #dateOfMarriage="ngModel" [name]="'dateOfMarriage' + idx" label="Date of marriage"
        [(ngModel)]="currentDependent.partnershipStartDate"></date-picker>
    </div>
  </div>
  <checkbox bold name="addressSameAsSubscriber{{idx}}" [(ngModel)]="currentDependent.addressSameAsSubscriber">
    {{ selfPay.isPEBB && selfPay.isLwopOE ? 'Street' : selfPay.isPEBB && (selfPay.isCobraOE || selfPay.isCobraInitial || selfPay.isLwopInitial) ? 'Permanent street' : 'Residential' }} address is
    the same as subscriber
  </checkbox>
  <div class="form-row" *ngIf="!currentDependent.addressSameAsSubscriber">
    <address #residentialAddress view="inline" name="residentialAddress" [hideCounty]="!(selfPay.isPEBB && selfPay.isLwopOE)"
      [(ngModel)]="currentDependent.residentialAddress"></address>
    <div *ngIf="selfPay.isPEBB && (selfPay.isCobraOE || selfPay.isCobraInitial)" style="margin-bottom: 20px;">
      PO Box not allowed.
    </div>
    <div *ngIf="selfPay.isPEBB && selfPay.isRetireeOE" style="margin-bottom: 20px;">
      PO Box is not allowed for Medicare enrollment.
      1. <i>This field is required for health care services. </i>
      2. <i>This field is not required for enrollment. Your response is optional and will be kept private to the extent allowable by law. Gender X means a gender that is not exclusively male nor female. To learn more visit <a target="_blank" href="https://www.hca.wa.gov/about-hca/other-administrative-activities/gender-identity-information">Gender X.</a></i>
    </div>
    <div style="margin-bottom: 20px;" *ngIf="!selfPay.isRetireeSOE && !selfPay.isRetireeOE && !(selfPay.isPEBB && selfPay.isCobraSOE)">
      Enrollment in Medicare Advantage with Part D Plans <span *ngIf="selfPay.isCobraOE">or </span><span *ngIf="!selfPay.isCobraOE">and </span> UMP Classic Medicare with Part D (PDP) has specific requirements associated with 
      residential addresses. PO boxes and out-of-country addresses will be reviewed by HCA for eligibility. 
      Proof of <span *ngIf="selfPay.isCobraOE">permanent </span>residence may need to be provided.
    </div>
  </div>
  <div class="form-row" fxFlexFill *ngIf="!selfPay.isRetireeOE">
    <div fxLayout="column" fxFlex="100">
      <div class="hca-selfPay-divider" fxFlex="45"></div>
      <span class="hca-selfPay-small-note" fxFlex="100"> 1. This field is required for health care services. </span>
      <span class="hca-selfPay-small-note" fxFlex="100">
        2. This field is not required for enrollment. Your response is optional and will be kept private to the extent allowable by law. Gender X means a gender that is not exclusively male nor female. To learn more visit <a target="_blank" href="https://www.hca.wa.gov/about-hca/other-administrative-activities/gender-identity-information">Gender X.</a>
      </span>
    </div>
  </div>
  <!-- COVERAGE -->
  <div>
    <div class="form-row" style="padding-top: 20px" fxFlexFill>
      <h4>Coverage options</h4>
      <span class="soe-form-small-header">Enroll dependent in (or remain enrolled)</span>
    </div>
    <div class="form-row" fxFlexFill>
      <div>
        <div fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px"
            class="fxGap-medium-sm">
            <div class="k-form-field bigger" fxFlex="30">
              <checkbox name="medicalEnrollInd" [(ngModel)]="currentDependent.medicalCoverInd"
                (ngModelChange)="handleMedicalEnrollChange($event)">Medical</checkbox>
            </div>
            <div class="k-form-field bigger" fxFlex="30">
              <checkbox name="dentalEnrollInd" [(ngModel)]="currentDependent.dentalCoverInd"
                (ngModelChange)="currentDependent.terminateAllCoverageInd = false">Dental
              </checkbox>
            </div>
            <div class="k-form-field bigger" fxFlex="30">
              <checkbox name="visionEnrollInd" [(ngModel)]="currentDependent.visionCoverInd"
                (ngModelChange)="currentDependent.terminateAllCoverageInd = false" [disabled]="(!isSebbCobra && currentDependent.medicarePartBInd)">
                Vision</checkbox>
            </div>
          </div>
        </div>
        <div *ngIf="isPebbRetireeVision || (selfPay.isPEBB && selfPay.isRetireeSOE)" fxLayout="column" fxFlex="50"
          fxFlex.fxFlex.lt-md="100" fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
            <span *ngIf="!selfPay.isRetireeInitial && !selfPay.isRetireeSOE">
              Dependents will be enrolled in the same coverage as you (the subscriber). The exceptions are:
              <br />
              <br />
              <ol>
                <li>The standalone vision option is available for non-Medicare enrolled dependents if subscriber is
                  enrolled in Medicare</li>
                <li>If you are deferring due to Medicare/Medicaid, your dependent can enroll in coverage you aren't
                  enrolled in. </li>
              </ol>
              <br />
              <div *ngIf="!(selfPay.isPEBB && selfPay.isCobraSOE)">Coverage that is terminated will end December 31 of
                the current year and could require additional forms to be submitted if enrolled in a Medicare Advantage
                (MA) or Medicare Advantage Prescription Drug Plan (MAPD). Also submit <a target="_blank"
                  href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">Form
                  D</a></div>
              <a *ngIf="selfPay.isPEBB && selfPay.isCobraSOE" target="_blank"
                href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">Form
                D</a>
            </span>
            <span *ngIf="selfPay.isRetireeInitial || selfPay.isRetireeSOE">
              Dependents can only be enrolled in the same coverages that are elected for the subscriber. The exceptions
              are:
              <br />
              <br />
              <ol>
                <li>Standalone vision coverage is available for non-Medicare enrolled dependents if subscriber is
                  enrolled in Medicare.</li>
                <li>
                  <p>
                    If subscriber is deferring due to Medicare/Medicaid, the dependent can enroll in coverages the
                    subscriber isn't also enrolled in.
                  </p>
                  <p>
                    Coverage that is terminated will end at the end of the current calendar/plan year and could require
                    additional forms to be submitted if
                    enrolled in a Medicare Advantage (MA), Medicare Advantage Prescription Drug Plan (MAPD) or a Part D
                    plan.
                  </p>
                </li>
              </ol>
              Response required if your are enrolling dependents age 13 and older in medical coverage. If you check Yes
              or do not check any boxes below,
              you will be charged the $25-per-account premium surcharge in addition to your monthly medical premium.
            </span>
          </div>
        </div>
        <div *ngIf="selfPay.isSEBB && selfPay.isCobraOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
            <span>
              Choose the coverage you wish to enroll this dependent in (or remain enrolled in). If you wish to terminate
              an existing
              coverage, deselect the coverage and it will end on December 31 of the current year.
            </span>
          </div>
        </div>
        <div *ngIf="selfPay.isPEBB && selfPay.isCobraOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
            <span>
              <p>
                Choose the coverage you wish to enroll this dependent in (or remain enrolled in). If you wish to
                terminate existing coverage,
                deselect the coverage and it will end on December 31 of the current year.
              </p>
              <p>
                Terminating coverage from a Medicare Advantage with Part D plan or UMP Classic Medicare with Part D (PDP) also requires a 
                <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">PEBB Medicare Plan Disenrollment form (form D)</a>
              </p>
            </span>
          </div>
        </div>
        <div *ngIf="isPebbCobraInitial || isPebbCobraSOE" fxLayout="column" fxFlex="50" fxFlex.fxFlex.lt-md="100"
          fxLayoutAlign="space-between" class="fxGap-small">
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="start center" style="margin-bottom: 20px">
            <span>
              Choose the coverage you wish to enroll this dependent in (or remain enrolled in). 
              <br />
              <br />
              Terminating coverage from a Medicare Advantage with Part D plan or UMP Classic Medicare with Part D (PDP) also 
              <a target="_blank" href="https://www.hca.wa.gov/assets/pebb/51-0556-pebb-medicare-plan-disenrollment-form-d-2025.pdf">requires a PEBB Medicare Plan Disenrollment form (form D)</a>
            </span>
          </div>
        </div>
      </div>
      <div class="form-row" fxFlexFill style="margin-bottom: 20px" *ngIf="selfPay.isPEBB && selfPay.isCobraSOE">
        Enrollment in Medicare Advantage Plans (MAPD) or Medicare Part D has specific requirements associated with
        residential addresses.
        PO boxes and out-of-country addresses may not be eligible for MAPD/Part D enrollment and will need to be
        reviewed
        by HCA for eligibility.
        Proof of residence may need to be provided.
      </div>

      <div class="form-row" fxFlexFill *ngIf="selfPay.isPEBB && selfPay.isCOBRA">
        <div fxLayout="column" fxFlexFill>
          <span class="soe-form-small-header">Terminate coverage (Select all that apply)</span>
          <div>
            You may choose to continue coverage and then terminate it at a future date by selecting to both continue and
            terminate coverage and providing a termination date and reason below.
          </div>
          <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between" style="margin-bottom: 20px">
            <div class="k-form-field bigger">
              <checkbox name="medicalTerminateCoverage" [(ngModel)]="currentDependent.medicalTerminateCoverage">Medical
              </checkbox>
            </div>
            <div class="k-form-field bigger">
              <checkbox name="dentalTerminateCoverage" [(ngModel)]="currentDependent.dentalTerminateCoverage">Dental
              </checkbox>
            </div>
            <div class="k-form-field bigger">
              <checkbox name="visionTerminateCoverage" [(ngModel)]="currentDependent.visionTerminateCoverage">Vision
              </checkbox>
            </div>
          </div>
          <div fxLayout="row" fxFlex="100" fxLayoutAlign="space-between" style="margin-bottom: 20px">
            <div class="form-group" fxFlex="25">
              <date-picker #terminationDate="ngModel" name="terminationDate" label="Termination date"
                [required]="currentDependent.medicalTerminateCoverage || currentDependent.dentalTerminateCoverage || currentDependent.terminateLifeAndADDCoverageInd"
                onlyAllowLastOfMonth [(ngModel)]="currentDependent.medicalTerminateCoverageDate"></date-picker>
            </div>
            <div class="form-group" fxFlex="70">
              <label for="ultermreason">Term Reason</label>
              <input
                [required]="currentDependent.medicalTerminateCoverage || currentDependent.dentalTerminateCoverage || currentDependent.terminateLifeAndADDCoverageInd"
                type="text" class="form-control" name="ultermreason" id="ultermreason"
                [(ngModel)]="currentDependent.medicalTerminateCoverageReason" />
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="otherCoverageSection"></ng-container>
    </div>
    <div class="form-row" fxFlexFill *ngIf="!(selfPay.isPEBB && (selfPay.isCobraSOE || selfPay.isCobraInitial))">
      <div>
        <div fxLayout="row" fxFlex="100">
          <div fxLayout="row" [fxFlex]="!(selfPay.isPEBB && selfPay.isRetireeSOE) ? 100 : 30" fxLayoutAlign="start center" class="fxGap-medium-sm"
            style="margin-bottom: 20px">
            <div class="k-form-field bigger" fxFlex="100">
              <checkbox name="deferCoverageInd" [disabled]="currentDependent.actionsCode === 'deferring'"
                [(ngModel)]="currentDependent.terminateAllCoverageInd"
                (ngModelChange)="terminateAllCoveragesChange($event)">Terminate all coverage(s)</checkbox>
            </div>
          </div>
          <div class="form-inline" fxFlex="30" *ngIf="selfPay.isPEBB && selfPay.isRetireeSOE">
            <div class="form-group">
              <date-picker #terminateAllCoverageDate="ngModel" name="terminateAllCoverageDate"
                [required]="currentDependent.terminateAllCoverageInd"
                [(ngModel)]="currentDependent.terminateAllCoverageDate">
                <span style="white-space: nowrap; margin-right: 20px">Termination date</span>
              </date-picker>
            </div>
          </div>
          <div class="form-inline" fxFlex="30" *ngIf="selfPay.isPEBB && selfPay.isRetireeSOE">
            I understand by terminating coverage I am forfeiting all further rights to enroll again unless I regain
            eligibility. I understand I must also submit a PEBB Medicare Advantage Plan Disenrollment Form (form D) ir
            I or an enrolled dependent is in an Medicare Advantage Plan or Medicare Part D.
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- MEDICARE -->
  <div class="form-row" fxFlexFill style="margin-bottom: 20px">
    <span class="soe-form-small-header">Medicare information</span>
    <span style="width: 100%; margin-bottom: 15px"><b>Are you enrolled in Medicare Part A or Part B?</b></span>
    <div fxLayout="row" fxFlexFill class="fxGap-large">
      <div fxLayout="column">
        <div>
          <label for="medicarePartA" class="k-label">Part A (hospital)</label>
        </div>
        <yes-no name="medicarePartA" style="width: auto;" orientation="horizontal-list" [stretch]="false"
          [required]="requestType === 'R' || requestType === 'C'" [(ngModel)]="currentDependent.medicarePartAInd"
          [disabled]="disableFormForNoCoverage" (ngModelChange)="updateMedicarePartA($event)"></yes-no>
      </div>
      <div class="form-inline">
        <div class="form-group">
          <date-picker #medicarePartADate="ngModel" name="medicarePartADate" labelFlex="70" inputFlex="30"
            [min]="currentDependent.birthDate" [required]="currentDependent.medicarePartAInd"
            [disabled]="disableFormForNoCoverage" [(ngModel)]="currentDependent.medicarePartADate">
            <span style="white-space: nowrap; margin-right: 20px">If yes, enter the effective date shown on the Medicare
              card</span>
          </date-picker>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxFlexFill style="margin-top: 15px" class="fxGap-large">
      <div fxLayout="column">
        <div>
          <label for="medicarePartB" class="k-label">Part B (medical)</label>
        </div>
        <yes-no name="medicarePartB" style="width: auto;" orientation="horizontal-list" [stretch]="false"
          [required]="requestType === 'R' || requestType === 'C'" [disabled]="disableFormForNoCoverage"
          [(ngModel)]="currentDependent.medicarePartBInd" (ngModelChange)="updateMedicarePartB($event)"></yes-no>
      </div>
      <div class="form-inline">
        <date-picker #medicarePartBDate="ngModel" name="medicarePartBDate" labelFlex="70" inputFlex="30"
          [min]="currentDependent.birthDate" [required]="currentDependent.medicarePartBInd"
          [disabled]="disableFormForNoCoverage" [(ngModel)]="currentDependent.medicarePartBDate">
          <span style="white-space: nowrap; margin-right: 20px">If yes, enter the effective date shown on the Medicare
            card</span>
        </date-picker>
      </div>
    </div>
    <div class="form-group" fxFill>
      <label for="suffix">Medicare number (11 digits)</label> <b> Please verify the accuracy of your Medicare
        Beneficiary Number (MBI)</b>
      <input pattern="[a-zA-Z0-9]*" type="text" class="form-control" id="medicareNumber" name="medicareNumber"
        [(ngModel)]="currentDependent.medicareNumber" minlength="11" maxlength="11" />
    </div>
    <p *ngIf="isPebbRetireeVision && !selfPay.isRetireeInitial">
      If Yes, proof is required. Upload or mail a copy of all pages of your Medicare benefit verification letter or a
      copy of your Medicare card if we don't already have a copy. If mailing, write your last name and
      the last four digits of your Social Security Number on the copy so we can identify your account. If you are
      eligible for Medicare, you must enroll and stay enrolled in both Medicare Part A
      and Part B to keep PEBB retiree health plan coverage.
    </p>
    <p *ngIf="selfPay.isPEBB && selfPay.isCobraInitial">
      If Yes, proof is required. Upload or mail a copy of their Medicare benefit verification letter or a
      copy of their Medicare card. Write your full name and the last four digits of your Social Security number
      on the copy. Your spouse or SRDP will not be enrolled until their proof of Medicare is received.
    </p>
    <p *ngIf="isPebbRetireeVision && selfPay.isRetireeInitial">
      If Yes, proof is required. Upload or mail a copy of all pages of their Medicare benefit verification letter or a
      copy of their Medicare card
      if we don't already have a copy. If mailing, write the subscribers full name and the last four digits of their
      Social Security Number on the
      copy so we can identify your account. If your dependent is eligible for Medicare, they must enroll and stay
      enrolled in both Medicare Part A
      and Part B.
    </p>
    <p *ngIf="(selfPay.isPEBB && selfPay.isCobraSOE) || selfPay.isCobraOE">
      If Yes, proof is required. Upload or mail a copy of your Medicare benefit verification letter or a copy of your Medicare
      card. Write your full
      name and the last four digits of your Social Security number on the copy. You could face penalties if you don't
      enroll in Medicare Part A and Part B
      when you become eligible. Federal rules do not allow you to waive Medicare while on COBRA coverage.
    </p>
  </div>

  <div *ngIf="requestType.selfPayTypeCode === 'R' || requestType.selfPayTypeCode === 'OER'" fxLayoutAlign="row">
    <fa-icon fxFlex="5" [icon]="icons.faExclamationCircle" color="primary" size="1x"></fa-icon><span>Premium surcharges
      do not apply if subscriber is enrolled in Medicare Part A and Part B</span>
  </div>

  <div class="form-row" fxFlexFill style="margin-bottom: 20px">
    <div *ngIf="currentDependent.birthDate < thirteenYearsDate" fxLayout="column" fxFlex="100"
      fxLayoutAlign="space-between">
      <span class="selfPay-form-small-header">Tobacco use premium surcharge</span>
      <span style="padding-bottom: 10px">
        <span *ngIf="currentDependent.relationshipTypeName === 'Spouse/state-registered domestic partner'">
          Response required if you are enrolling your spouse or state-registered domestic partner (SRDP) in medical
          coverage. If you check Yes or do not check any boxes below, you will be charged the
          $25-per-account premium surcharge in addition to your monthly medical premium.
        </span>
        <span *ngIf="currentDependent.relationshipTypeName !== 'Spouse/state-registered domestic partner'">
          Response required if you are enrolling dependents age 13 and older in medical coverage. If you check Yes or do
          not check any boxes below, you will be charged the $25-per-account premium
          surcharge in addition to your monthly medical premium.
        </span>
        <span *ngIf="(selfPay.isCobraInitial || selfPay.isCobraOE) && !selfPay.isSEBB">
            <br/>
            <br/>
            Premium surcharges do not apply to subscribers who are enrolled in Medicare Part A and Part B. 
          </span>
        <br />
        <br />
        <b>Does the tobacco use premium surcharge apply to you?</b> Check one:
      </span>
      <div
        *ngIf="requestType.selfPayTypeCode !== 'U' && requestType.selfPayTypeCode !== 'OEU' && requestType.selfPayTypeCode !== 'SOEU' && (agency != 'SEBB' || !isCobra)"
        class="k-form-field bigger" style="margin-bottom: 15px">
        <checkbox [disabled]="disableFormForNoCoverage" [name]="'tobaccoNA' + idx"
          [(ngModel)]="currentDependent.surchargeNA" (change)="updateTobacco()">
          <b *ngIf="selfPay.isRetireeInitial">No,</b> Subscriber is enrolled in Medicare Part A and Part B. Premium
          surcharge does not apply.
        </checkbox>
      </div>
      <div class="k-form-field bigger" style="margin-bottom: 15px">
        <radio [disabled]="disableFormForNoCoverage" [name]="'tobaccoYes' + idx"
          [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" radioAsCheckbox [value]="true"
          [(ngModel)]="currentDependent.tobaccoUseInd">
          <b>Yes,</b> I am subject to the $25 premium surcharge. This dependent has used tobacco products in the past
          two months.
        </radio>
      </div>
      <div class="k-form-field bigger" style="margin-bottom: 20px" class="hca-mid-sz">
        <radio [disabled]="disableFormForNoCoverage" [name]="'tobaccoNo' + idx"
          [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" radioAsCheckbox [value]="false"
          [(ngModel)]="currentDependent.tobaccoUseInd">
          <b>No,</b> I am not subject to the $25 premium surcharge. This dependent has not used tobacco products in the
          past two months or has enrolled in or accessed one of the <a target="_blank" href="https://www.hca.wa.gov/employee-retiree-benefits/living-tobacco-free-pebb">tobacco cessation
          resources<span *ngIf="!selfPay.isLwopInitial && !selfPay.isLwopOE"> noted</span></a>.
        </radio>
      </div>
    </div>
  </div>

  <div *ngIf="currentDependent.relationshipTypeName === 'Spouse/state-registered domestic partner'" class="form-row"
    fxFlexFill style="margin-bottom: 20px">
    <div fxLayout="column" fxFlex="100" fxLayoutAlign="space-between">
      <span class="selfPay-form-small-header">Spouse or state-registered domestic partner (SRDP) coverage premium
        surcharge </span>
      <span style="padding-bottom: 10px">
        Response required if you are enrolling your spouse or SRDP in medical coverage. The {{agency}} Program requires
        a $50 premium surcharge in addition to your monthly medical premium if you are
        enrolling your spouse or SRDP in {{agency}} medical and they have chosen not to enroll in another employer-based
        group medical plan that is comparable to PEBB's Uniform Medical Plan Classic.
        <br />
        <div *ngIf="(selfPay.isCobraOE || selfPay.isCobraInitial) && !selfPay.isSEBB">
          <br/>
          <a target="_blank" [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/sebb-continuation-coverage/tobacco-use-surcharge' : 'https://www.hca.wa.gov/employee-retiree-benefits/pebb-continuation-coverage/spousal-coverage-surcharge'">Learn about this surcharge</a> before you make your attestation.
          <br/><br/>
           Premium surcharges do not apply to subscribers who are enrolled in Medicare Part A and Part B. 
        </div>
        <br />
        <b>Answer these questions for your spouse or SRDP in {{coverageYear}}:</b>
        <div fxLayout="column">
          <ol class="hca-ordered-list">
            <li><yes-no name="spouseAttestQ1" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ1" (change)="spousalChange(currentDependent)">
                Are you covering your spouse or SRDP in a {{agency}} medical plan?
              </yes-no></li>
            <li><yes-no name="spouseAttestQ2" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ2" (change)="spousalChange(currentDependent)">
                Will they be eligible for medical coverage through their employer? (If they will not
                be employed, answer No.)
              </yes-no></li>
            <li><yes-no name="spouseAttestQ3" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ3" (change)="spousalChange(currentDependent)">
                Will their employer offer at least one medical plan that serves their county of residence?
              </yes-no></li>
            <li><yes-no name="spouseAttestQ4" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ4" (change)="spousalChange(currentDependent)">
                Have they chosen not to enroll in their employer's medical coverage?
              </yes-no></li>
            <li><yes-no name="spouseAttestQ5" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ5" (change)="spousalChange(currentDependent)">
                Will the coverage offered by their employer <b>not</b> be through the PEBB Program, SEBB Program, or a TRICARE plan?<br/>
                Answer Yes if their employer does <b>not</b> offer PEBB or SEBB coverage, or a TRICARE plan.<br/>
                Answer No if their employer offers PEBB or SEBB coverage, or a TRICARE plan.
              </yes-no></li>
            <li><yes-no name="spouseAttestQ6" [stretch]="false" style="width: auto;" orientation="horizontal-list"
                [disabled]="disableFormForNoCoverage" [useContentAsLabel]="true"
                [(ngModel)]="currentDependent.spouseAttestQ6" (change)="spousalChange(currentDependent)">
                Will their share of the medical premium through their employer be less than 
                ${{ (coverageYear >= 2026 ? '137.76' : (coverageYear == 2025 ? '126.36' : '117.81'))}} per month?
              </yes-no></li>
          </ol>
        </div>
        If you answered No to any of these questions, check no below. You will not be charged the surcharge.
        If you answered Yes to all {{ selfPay.isPEBB && selfPay.isCobraOE ? '' : 'of' }} these questions:
        <br />
        <br />
        <ol>
          <li>Ask your spouse or SRDP for the Summary of Benefits and Coverage (SBC) for all medical plans that:
            <ol type="a">
              <li>Serve their county of residence.</li>
              <li>Have a monthly premium of less than 
                ${{ (coverageYear >= 2026 ? '137.76' : (coverageYear == 2025 ? '126.36' : '117.81'))}} per month for the
                employee.</li>
            </ol>

          </li>
          <li>Use the SBC information to answer the questions in the {{agency}} Spousal Plan Calculator online tool. You
            will get a Yes or No response from the calculator. Enter your response below.</li>
        </ol>
        <br />
        <b>Does the spouse or SRDP coverage premium surcharge apply to you?</b> Check one:
      </span>
      <radio *ngIf="selfPay.isPEBB && (selfPay.isCobraOE || selfPay.isLwopOE)" [name]="'spouseSurchargeNAMedicare' + idx" radioAsCheckbox
          [disabled]="currentDependent.surchargeNA" value="NAMedicare"
          [(ngModel)]="currentDependent.spouseSurchargeTriState">
          No, I am enrolled in Medicare Part A and Part B. The premium surcharge does not apply.
      </radio>
      <div fxlayout="row" fxFlex="100" fxLayoutAlign="space-between">
        <radio [name]="'spousalYes' + idx" radioAsCheckbox
          [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="Y"
          [(ngModel)]="currentDependent.spouseSurchargeTriState">
          <b>Yes,</b> I am subject to the $50 premium surcharge. I completed the {{coverageYear}}
          <a [href]="selfPay.isSEBB ? 'https://www.hca.wa.gov/employee-retiree-benefits/school-employees/spousal-plan-calculator' : 'https://www.hca.wa.gov/employee-retiree-benefits/spousal-plan-calculator'"
            target="_blank">{{agency}} Spousal Plan Calculator</a> online.
        </radio>
        <span class="selfPay-form-small-header" fxFlex="40">
          <fa-icon class="hca-fontawesome-icon" [icon]="icons.faExclamationCircle"></fa-icon>
          If you check <b>Yes</b> or do not check any boxes below, you will be charged the $50 spouse or SRDP coverage
          premium surcharge.
        </span>
      </div>
      <radio [name]="'spousalNo' + idx" radioAsCheckbox
        [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="N"
        [(ngModel)]="currentDependent.spouseSurchargeTriState">
        <b>No,</b> I am not subject to the $50 premium surcharge. I completed the {{agency}} Spousal Plan Calculator
        online.
      </radio>
      <radio [name]="'spousalHelp' + idx" radioAsCheckbox
        [disabled]="currentDependent.surchargeNA || disableFormForNoCoverage" value="H"
        [(ngModel)]="currentDependent.spouseSurchargeTriState">
        The {{agency}} Program to help determine if premium surcharge applies. I am completing and submitting a printed
        {{agency}} Spousal Plan
        Calculator.
      </radio>
    </div>
  </div>

  <div fxFlexFill fxLayout="row" fxLayoutAlign="space-between" style="margin-bottom: 10px;">
    <button fxFlex="30" (click)="cancelChanges()" class="btn btn-light">Cancel</button>
    <button fxFlex="30" [disabled]="!currentDependent.confirmed" (click)="emitSubmitDependent(formContainer)"
      class="btn btn-primary">Save and Continue</button>
  </div>
  <div fxLayout="row" fxLayoutAlign="space-between">
    <div></div>
    <div fxLayout="column" fxFlex="30">
      <div *ngIf="currentDependent.terminateAllCoverageInd">
        <b>
          You have not elected any coverage for this dependent and they will be terminated from existing coverage(s) at
          the end of the current calendar/plan year (if currently covered).
        </b>
      </div>
      <div class="k-form-field bigger">
        <checkbox name="confirmContinue{{idx}}" [(ngModel)]="currentDependent.confirmed">Confirm to continue
        </checkbox>
      </div>
    </div>
  </div>
</form>